import angular from "angular"
import "../edition/edition"
import "../autocomplete/autocompleteModule"

export default angular.module("driverModule", ["editionModule", "autocompleteModule"])